import React from 'react'
import { Row, Col, Panel } from 'rsuite'

export default function ExpenseCheckView({ schema, ...props }) {
  return (
    <Panel>
      <Row style={{ marginTop: 10 }}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b>{schema.voucherNumber.label} : </b>
          {schema.voucherNumber.value}
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b>{schema.voucherDate.label} : </b>
          {schema.voucherDate.value}
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b>{schema.checkNumber.label} : </b>
          {schema.checkNumber.value}
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b>{schema.checkDate.label} : </b>
          {schema.checkDate.value}
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b>{schema.checkStatus.label} : </b>
          {schema.checkStatus.value}
        </Col>
      </Row>
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b>{schema.checkClearingDate.label} : </b>
          {schema.checkClearingDate.valueDef}
        </Col>
      </Row>
    </Panel>
  )
}
